import { EditSpeakingSessionRoomRequest, speakingSessionRoomClient } from 'api/planning';
import { api } from '../api';
import {
  SPEAKING_SESSION_ALLOWED_ACTIONS_QUERY_TAG,
  SPEAKING_SESSION_ROOMS_LIST_QUERY_TAG,
} from 'store';
import { invalidateOn } from 'utils';

export const speakingSessionRoomApi = api.injectEndpoints({
  endpoints: (builder) => ({
    editSpeakingSessionRoom: builder.mutation<
      void,
      {
        speakingSessionId: number;
        speakingSessionRoomId: number;
        request: EditSpeakingSessionRoomRequest;
      }
    >({
      query: ({ speakingSessionId, speakingSessionRoomId, request }) =>
        speakingSessionRoomClient.editSpeakingSessionRoom(speakingSessionId, speakingSessionRoomId, request),
      invalidatesTags: invalidateOn({
        success: [
          SPEAKING_SESSION_ROOMS_LIST_QUERY_TAG,
          SPEAKING_SESSION_ALLOWED_ACTIONS_QUERY_TAG
        ]
      })
    }),
  }),
});

export const { useEditSpeakingSessionRoomMutation } = speakingSessionRoomApi;
